import { GOSPEL_FRAGMENTS } from "../config/gospelQuotes";

const GOSPEL_CHARS = GOSPEL_FRAGMENTS.join("").replace(/\s/g, "");

export function gospelChar() {
  return GOSPEL_CHARS.charAt(Math.floor(Math.random() * GOSPEL_CHARS.length));
}

export function dictationText(input) {
  if (!input) return "";
  if (typeof input === "string") return input;
  return input.transcript || "";
}

/** Preserve the old scramble effect for plain interim strings only. */
export function scrambledTentativeDisplay(text) {
  if (!text) return "";
  const words = String(text).split(" ");
  const last = words[words.length - 1];
  if (!last) return text;
  const i = Math.floor(Math.random() * last.length);
  words[words.length - 1] = last.slice(0, i) + gospelChar() + last.slice(i + 1);
  return words.join(" ");
}

/**
 * For old string-only interim results, keep the current visual flavor.
 * For Deepgram rich payloads, keep the object so the canvas can render
 * confidence-aware words instead of flattening useful metadata.
 */
export function tentativeDisplay(input) {
  if (!input) return "";
  if (typeof input === "string") return scrambledTentativeDisplay(input);
  return input;
}

export function appendChunk(base, chunk) {
  const text = dictationText(chunk);
  if (!text) return base;
  const gap = base && !base.endsWith(" ") ? " " : "";
  return base + gap + text;
}

export function pauseSeparator(ms) {
  if (ms == null) return " ";
  if (ms < 900) return " ";
  if (ms < 1800) return ", ";
  if (ms < 4500) return ". ";
  if (ms < 12000) return ".\n\n";
  return "\n\n---\n\n";
}

function isPunctuationEnd(str) {
  return /[.,]$/.test(str);
}

function dedupeSeparator(baseSansTrailingSpaces, sep) {
  const baseEnd = baseSansTrailingSpaces;
  if (!sep) return sep;

  // Avoid ",," and ".." by removing the punctuation we would otherwise add.
  if (sep.startsWith(",") && baseEnd.endsWith(",")) return " ";
  if (sep.startsWith(".") && baseEnd.endsWith(".")) {
    // ". " -> " ", ".\n\n" -> "\n\n"
    return sep.slice(1).replace(/^ ?/, "");
  }
  return sep;
}

export function appendDictationChunk(base, chunk, pauseMs) {
  const safeBase = base || "";
  const safeChunk = dictationText(chunk).trim();
  if (!safeChunk) return safeBase;

  // Remove only spaces/tabs at the end; keep newlines intact.
  const baseSansTrailingSpaces = safeBase.replace(/[ \t]+$/, "");

  let sep = pauseSeparator(pauseMs);
  sep = dedupeSeparator(baseSansTrailingSpaces, sep);

  // If Deepgram already included punctuation at the end of the base,
  // keep the chunk spacing reasonable (no double punctuation).
  if (sep !== " " && isPunctuationEnd(baseSansTrailingSpaces)) {
    // Let dedupeSeparator handle "." and ","; for other separators just keep.
  }

  return baseSansTrailingSpaces + sep + safeChunk;
}
